import type { ReactNode } from 'react'
import styles from './MessageCard.module.css'

export interface MessageCardProps {
  children?: ReactNode
}

export function MessageCard({ children }: MessageCardProps) {
  return <div className={styles.card}>{children}</div>
}

export interface MessageCardContentProps {
  visual?: ReactNode
  title?: ReactNode
  children?: ReactNode
}

export function MessageCardContent({
  visual,
  title,
  children,
}: MessageCardContentProps) {
  return (
    <div className={styles.cardContent} data-slot="message-card-content">
      {visual && <div className={styles.cardContentVisual}>{visual}</div>}
      <div className={styles.cardContentCopy} data-slot="message-card-copy">
        {title && (
          <h3
            className={styles.cardContentTitle}
            data-slot="message-card-title"
          >
            {title}
          </h3>
        )}
        <p>{children}</p>
      </div>
    </div>
  )
}

export interface MessageCardFooterProps {
  children?: ReactNode
}

export function MessageCardFooter({ children }: MessageCardFooterProps) {
  return <div className={styles.cardFooter}>{children}</div>
}

export interface MessageCardFooterItemProps {
  children?: ReactNode
}

export function MessageCardFooterItem({
  children,
}: MessageCardFooterItemProps) {
  return <div className={styles.cardFooterItem}>{children}</div>
}

export function MessageCardFooterSpacer() {
  return <div className={styles.cardFooterSpacer} />
}
